import { useState, useEffect } from 'react';
import Status from '../Constants/Status';

function useRequest(
  request,
  params,
  initleData,
  isDisabled = false,
  customDependencyArr = undefined,
  options = {}
) {
  const [result, setResult] = useState({
    data: initleData,
    status: Status.Empty,
    ErrorMessage: '',
    usedParams: undefined
  });

  useEffect(() => {
    if (!isDisabled) {
      RequestFlow();
    }
  }, [...(customDependencyArr ?? params), isDisabled]);

  useEffect(() => {
    if (options.clearOnDisabled && isDisabled) {
      setResult({
        data: initleData,
        status: Status.Empty,
        ErrorMessage: '',
        usedParams: undefined
      });
    }
  }, [isDisabled, options.clearOnDisabled]);

  const RequestFlow = () => {
    setResult(prevResult => ({
      ...prevResult,
      data: initleData,
      status: Status.Pending,
      ErrorMessage: '',
      usedParams: undefined
    }));
    request(...params)
      .then(res => {
        setResult(prevResult => ({
          ...prevResult,
          status: Status.Fullfilled,
          data: res,
          usedParams: params
        }));
      })
      .catch(err => {
        setResult(prevResult => ({
          ...prevResult,
          status: Status.Rejected,
          ErrorMessage: err,
          usedParams: undefined
        }));
      });
  };
  return {
    data: result.data,
    status: result.status,
    ErrorMessage: result.ErrorMessage,
    update: RequestFlow,
    usedParams: result.usedParams
  };
}

export default useRequest;
